import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {prepareAuthHeaders} from "../../utils/prepareAuthHeaders";

export const documentApi = createApi({
  reducerPath: 'documentApi',
  keepUnusedDataFor: 0,
  tagTypes: ['RegistryDocuments'],
  baseQuery: fetchBaseQuery({
    baseUrl: '/Document',
    prepareHeaders: prepareAuthHeaders
  }),
  endpoints: (builder) => ({
    getRegistryDocuments: builder.query({
      query: ({ page, pageSize, search }) => ({
        url: `/GetRegistryDocuments`,
        method: 'GET',
        params: { page, pageSize, search },
      }),
      providesTags: ['RegistryDocuments'],
    }),
    getRegistryDocument: builder.query({
      query: ({ documentId }) => ({
        url: `/GetRegistryDocument`,
        method: 'GET',
        params: { documentId },
      }),
    }),
    addToRegistry: builder.mutation({
      query: ({formData}) => ({
        url: `/AddToRegistry`,
        method: 'POST',
        body: formData
      }),
    }),
    getSkipDocuments: builder.query({
      query: () => ({
        url: `/GetSkipDocuments`,
        method: 'GET',
      }),
    }),
    deleteSkipDocument: builder.mutation({
      query: ({documentId}) => ({
        url: `/DeleteSkipDocument`,
        method: 'DELETE',
        params: {documentId}
      }),
    }),
    addSkipDocument: builder.mutation({
      query: () => ({
        url: `/AddSkipDocument`,
        method: 'POST',
      }),
    }),
    addCertificateOfSkipping: builder.mutation({
      query: ({data}) => ({
        url: `/AddCertificateOfSkipping`,
        method: 'POST',
        body: data
      }),
    }),
    getCertificatesOfSkipping: builder.query({
      query: ({groupId}) => ({
        url: `/GetCertificatesOfSkipping`,
        method: 'GET',
        params: {groupId}
      }),
    }),
    removeCertificateOfSkipping: builder.mutation({
      query: ({data}) => ({
        url: `/RemoveCertificateOfSkipping`,
        method: 'POST',
        body: data
      }),
    }),
    saveDocumentToRegistry: builder.mutation({
      query: ({data}) => ({
        url: `/SaveDocumentToRegistry`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['RegistryDocuments'],
    }),
    deleteDocumentFromRegistry: builder.mutation({
      query: ({ documentId }) => ({
        url: `/DeleteDocumentFromRegistry`,
        method: 'DELETE',
        params: { documentId },
      }),
      invalidatesTags: ['RegistryDocuments'],
    }),
  }),
});

export const { 
  useGetRegistryDocumentsQuery, 
  useGetRegistryDocumentQuery,
  useAddToRegistryMutation,
  useAddCertificateOfSkippingMutation,
  useGetCertificatesOfSkippingQuery,
  useRemoveCertificateOfSkippingMutation,
  useSaveDocumentToRegistryMutation,
  useDeleteDocumentFromRegistryMutation,
} = documentApi;
